import React from 'react';
import { Header } from '../components/Header';
import { Footer } from '../components/Footer';
import { SEO } from '../components/SEO';
import { ArrowLeftIcon, TargetIcon, BarChartIcon, LightbulbIcon } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { buildBreadcrumbList } from '../lib/structuredData';
export const TeamLid1Page: React.FC = () => {
  const navigate = useNavigate();
  return <div className="min-h-screen bg-white font-sans text-[#111827]" data-id="element-2672" data-mp="2cqob35vgb4cs">
      <SEO title="Rocco, oprichter en strateeg | Noord Digital" description="Maak kennis met Rocco, oprichter en strateeg bij Noord Digital in Oudkarspel. Aanspreekpunt voor ondernemers die online gevonden willen worden." keywords="rocco noord digital, oprichter noord digital, online strategie Noord-Holland" canonical="https://noorddigital.nl/over-ons/rocco" jsonLd={buildBreadcrumbList([{
      name: 'Over ons',
      path: '/over-ons'
    }, {
      name: 'Rocco',
      path: '/over-ons/rocco'
    }])} data-id="element-2673" data-mp="28qe2rmk6s1ur" />
      <Header data-id="element-2674" data-mp="20tkfzh16qwex" />

      <main className="pt-32 pb-20 lg:pt-40 lg:pb-24" data-id="element-2675" data-mp="20uvmhom0mi9q">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-2676" data-mp="25sxc6sdy5fu6">
          <button onClick={() => navigate('/over-ons')} className="inline-flex items-center gap-2 text-[#004AC7] font-medium hover:underline mb-12" data-id="element-2677" data-mp="25s5glhkcni3w">
            <ArrowLeftIcon className="w-4 h-4" data-id="element-2678" data-mp="1w2lwk8kwhi7g" /> Terug naar het team
          </button>

          <div className="flex flex-col lg:flex-row gap-16 items-start" data-id="element-2679" data-mp="1i3m9v6gy7ddx">
            <div className="lg:w-1/3 flex justify-center lg:justify-start" data-id="element-2680" data-mp="1i5fiusf1a9p3">
              <div className="w-[300px] h-[300px] rounded-full border-4 border-[#004AC7] overflow-hidden shadow-lg" data-id="element-2681" data-mp="1n40h4maq6jaw">
                <img src="https://cdn.magicpatterns.com/uploads/6NEVZ9gbtbKb9LzgRcu9P4/image.png" alt="Rocco" className="w-full h-full object-cover" style={{
                objectPosition: 'center 35%'
              }} data-id="element-2682" data-mp="194r4fwlqa7bo" />
              </div>
            </div>

            <div className="lg:w-2/3" data-id="element-2683" data-mp="37h9at24m26tp">
              <h1 className="text-4xl md:text-5xl font-bold text-[#111827] mb-2" data-id="element-2684" data-mp="37g6hknjtfsam">
                Rocco
              </h1>
              <p className="text-xl text-[#607697] font-medium mb-8" data-id="element-2685" data-mp="faqku770q86p">
                Oprichter & Strateeg
              </p>

              <div className="prose prose-lg text-[#4B5563] mb-12" data-id="element-2686" data-mp="b8dephod089e">
                <p className="mb-4" data-id="element-2687" data-mp="6a24v6y2dxr6">
                  Als oprichter van Noord Digital en bedenker van de CorePrint
                  methode, ben ik dagelijks bezig met het vertalen van complexe
                  bedrijfsdoelstellingen naar meetbare online strategieën. Mijn
                  passie ligt op het snijvlak van data, psychologie en
                  technologie.
                </p>
                <p className="mb-4" data-id="element-2688" data-mp="p8xus62w3pz7">
                  Voordat ik Noord Digital startte, zag ik te vaak dat bedrijven
                  investeerden in marketing zonder duidelijk plan of meetbaar
                  resultaat. Dat moest anders. Met CorePrint hebben we een
                  fundament gebouwd dat groei voorspelbaar maakt.
                </p>
                <p data-id="element-2689" data-mp="1pab2nkpsrr4z">
                  In mijn werk focus ik me op de grote lijnen: waar liggen de
                  kansen in de markt, hoe positioneren we onze klanten het
                  sterkst, en welke kanalen leveren de hoogste ROI op. Ik geloof
                  heilig dat elke beslissing onderbouwd moet worden met data,
                  niet met onderbuikgevoel.
                </p>
              </div>

              <h2 className="text-2xl font-bold text-[#111827] mb-6" data-id="element-2690" data-mp="285hzysx3bvms">
                Expertise
              </h2>
              <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-12" data-id="element-2691" data-mp="2d4ch7qfetc4s">
                <div className="bg-[#F7F8FA] p-6 rounded-xl border border-gray-100" data-id="element-2692" data-mp="2hy77xdtfmrdd">
                  <LightbulbIcon className="w-8 h-8 text-[#004AC7] mb-4" data-id="element-2693" data-mp="2mvyzu7u2udhk" />
                  <h3 className="font-bold text-[#111827]" data-id="element-2694" data-mp="2qyvdrl8o9lf6">Strategy</h3>
                </div>
                <div className="bg-[#F7F8FA] p-6 rounded-xl border border-gray-100" data-id="element-2695" data-mp="2vwf1rcv69ckb">
                  <TargetIcon className="w-8 h-8 text-[#004AC7] mb-4" data-id="element-2696" data-mp="2ia7tf2hpsb92" />
                  <h3 className="font-bold text-[#111827]" data-id="element-2697" data-mp="2i83iw1pb8dzt">CorePrint</h3>
                </div>
                <div className="bg-[#F7F8FA] p-6 rounded-xl border border-gray-100" data-id="element-2698" data-mp="2e6s12icogx26">
                  <BarChartIcon className="w-8 h-8 text-[#004AC7] mb-4" data-id="element-2699" data-mp="2rzho8q3y080v" />
                  <h3 className="font-bold text-[#111827]" data-id="element-2700" data-mp="2n27tqw1p5666">Data-analyse</h3>
                </div>
              </div>

              <a href="/#contact" className="inline-block bg-[#004AC7] text-white px-8 py-4 rounded-lg font-bold hover:bg-[#003A9E] transition-colors shadow-md" data-id="element-2701" data-mp="1zc3xj9qu88p7">
                Neem contact op met Rocco
              </a>
            </div>
          </div>
        </div>
      </main>

      <Footer data-id="element-2702" data-mp="249nb07fpohg3" />
    </div>;
};